import React, { useEffect, useState } from "react";
import DataTable from "../../components/Table/index.js";
import MobilePopUp from "../../components/MobilePopUp/MobilePopUp";
import {
  checkIFSC,
  FinalReconcileCall,
  getReconciliationData,
  saveReconciliationEditData,
} from "../../store/actions/paymentActions.js";
import { useDispatch, useSelector } from "react-redux";
import { convertDateInFormat, toaster } from "../../utils/utils.js";
import FilterComponent from "./FilterComponent.js";
import Select from "react-select";
const Reconciliation = () => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [ifscError, setIfscError] = useState("");
  const [reconciliationData, setReconciliationData] = useState([]);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [cancelRow, setCancelRow] = useState(null);
  const [statusFilter, setStatusFilter] = useState("");
  const [proposalNumberFilter, setProposalNumberFilter] = useState("");
  const [isBranchChangeConfirmed, setIsBranchChangeConfirmed] = useState(false);
  const [showReconcileMessage, setshowReconcileMessage] = useState('')

  const dispatch = useDispatch();
  const ifscData = useSelector((state) => state.paymentReducer.ifsc);
  const userDetails = localStorage.getItem("userDetails");
  const userId = JSON.parse(userDetails).user.code;
  const branchName = JSON.parse(userDetails).user.branch;
  const zone = JSON.parse(userDetails).user.zone;

  useEffect(() => {
    callReconciliationApi();
  }, []);

  useEffect(() => {
    if (ifscData?.bank) {
      setSelectedRow((prev) => ({
        ...prev,
        bankName: ifscData.bank,
      }));
    }
  }, [ifscData]);

  useEffect(()=>{
    if(filteredData.length === 0 && (statusFilter || proposalNumberFilter)){
      toaster("info", "No records found for the applied filters");
    }
  })

  const filteredData = reconciliationData.filter((row) => {
  const matchStatus = statusFilter
    ? row.receiptStatus === statusFilter
    : true;

  const matchProposal = proposalNumberFilter.length === 10
    ? row.proposalNumber?.toString().includes(proposalNumberFilter)
    : true;

  return matchStatus && matchProposal;
});


  const parseSubmissionDate = (date) => {
    if (!date) return null;
    const parsed = new Date(date);
    return isNaN(parsed.getTime()) ? null : parsed.getTime();
  };

  const sortReconciliationData = (data = []) => {
    return [...data].sort((a, b) => {
      const aIsFinal =
        a.reconciliationStatus === true &&
        a.receiptStatus !== "YET_TO_ACKNOWLEDGE";

      const bIsFinal =
        b.reconciliationStatus === true &&
        b.receiptStatus !== "YET_TO_ACKNOWLEDGE";

      // Final reconciled records go to bottom
      if (aIsFinal && !bIsFinal) return 1;
      if (!aIsFinal && bIsFinal) return -1;

      // Pending (Yet to Acknowledge) on top within same group
      const aIsPending = a.receiptStatus === "YET_TO_ACKNOWLEDGE";
      const bIsPending = b.receiptStatus === "YET_TO_ACKNOWLEDGE";

      if (aIsPending && !bIsPending) return -1;
      if (!aIsPending && bIsPending) return 1;

      // Sort by proposalSubmissionDate (oldest first)
      const aDate = parseSubmissionDate(a.proposalSubmissionDate);
      const bDate = parseSubmissionDate(b.proposalSubmissionDate);

      if (!aDate && !bDate) return 0;
      if (!aDate) return 1;
      if (!bDate) return -1;

      return aDate - bDate;
    });
  };

  const callReconciliationApi = async () => {
    const payload = {
      branchName: branchName,
      userId: userId,
      zone: zone,
    };
    const resp = await dispatch(getReconciliationData(payload));
    if (resp && resp.body) {
      const sortedData = sortReconciliationData(resp.body);
      setReconciliationData(sortedData);
      setshowReconcileMessage(sortedData.length === 0 && true)    
    }
  };

  const saveReconciliationData = async ({
    row,
    receiptStatus,
    cancellationReason = "",
    instrumentAcknowledgementDate,
  }) => {
    const payload = {
      ...row,
      receiptStatus,
      cancellationReason,
      branchName: branchName,
      userId: userId,
      zone: zone,
      instrumentAcknowledgementDate:
        instrumentAcknowledgementDate || row.instrumentAcknowledgementDate,
    };

    try {
      const resp = await dispatch(saveReconciliationEditData(payload));
      if (resp && resp.body) {
        const sortedData = sortReconciliationData(resp.body);
        setReconciliationData(sortedData);
      }
    } catch (error) {
      console.error("Save reconciliation failed", error);
    }
  };

  const prepareTableData = (data) => {
    return data.map((item, index) => ({
      ...item,

      edit: (
        <button
          className="reconcile-edit-btn"
          onClick={() => openEditPopup(item)}
          disabled={
            item.reconciliationStatus || item.paymentStatusCode === "PM"
          }
        >
          Edit
        </button>
      ),

      receiptStatus: (
        <select
          value={item.receiptStatus}
          onChange={(e) => onReceiptStatusChange(e.target.value, item)}
          className={`receipt-status-dropdown ${item.receiptStatus}`}
          disabled={
            item.reconciliationStatus || item.paymentStatusCode === "PM"
          }
        >
          <option value="ACKNOWLEDGED">Acknowledge</option>
          <option value="YET_TO_ACKNOWLEDGE">Yet to Acknowledge</option>
          <option value="CANCELLED">Cancelled</option>
        </select>
      ),
    }));
  };

  const openEditPopup = (row) => {
    setShowEditModal(true);

    const matchedBranch = branchList.find(
      (b) => b.code === row.branchName  
    );

    setSelectedRow({
      ...row,
      assignedBranchName: matchedBranch?.code || "",
    });
  };


  const closeEditPopup = () => {
    setShowEditModal(false);
    setIsBranchChangeConfirmed(false);
  };

  const onReceiptStatusChange = (value, row) => {
    if (value === "CANCELLED") {
      setCancelRow(row);
      setCancelReason("");
      setShowCancelModal(true);
      return;
    }
    saveReconciliationData({
      row,
      receiptStatus: value,
      instrumentAcknowledgementDate:
        value === "ACKNOWLEDGED"
          ? convertDateInFormat(new Date(), "DD-MM-YYYY HH:mm:ss")
          : row.instrumentAcknowledgementDate,
    });
    setReconciliationData((prev) =>
      prev.map((r) =>
        r.paymentId === row.paymentId
          ? { ...r, receiptStatus: value }
          : r
      )
    );
  };

  const updateEditField = (field, value) => {
    setSelectedRow((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleIfscChange = (value) => {
    const ifsc = value.toUpperCase();
    updateEditField("ifscCode", ifsc);

    if (ifsc.length > 11) return;

    if (ifsc.length < 11) {
      updateEditField("bankName", "");
      setIfscError("");
      return;
    }

    if (/^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifsc)) {
      setIfscError("");
      dispatch(checkIFSC(ifsc));
    } else {
      updateEditField("bankName", "");
      setIfscError("Incorrect IFSC format.");
    }
  };

  const handleEditSave = async () => {
    saveReconciliationData({
      row: selectedRow,
      receiptStatus: selectedRow.receiptStatus,
      cancellationReason: selectedRow.cancellationReason || "",
    });

    setShowEditModal(false);
  };

  const handleReconcile = async () => {
    const payload = reconciliationData
      .filter(
        (item) =>
          (item.receiptStatus === "ACKNOWLEDGED" ||
            item.receiptStatus === "CANCELLED") &&
          item.reconciliationStatus === false
      )
      .map((item) => ({
        branchName: branchName,
        userId: userId,
        zone: zone,
        cancellationReason:
          item.receiptStatus === "CANCELLED"
            ? item.cancellationReason || ""
            : "",
        paymentId: item.paymentId,
        proposalNumber: item.proposalNumber,
        receiptDateTime: new Date().toISOString(),
        reconciliationStatus: true,
        status: item.receiptStatus,
      }));
    if (!payload.length) {
      toaster("error", "No Acknowledged or Canceled records to reconcile");
      return;
    }

    try {
      const resp = await dispatch(FinalReconcileCall(payload));
      if (resp && resp.body) {
        const sortedData = sortReconciliationData(resp.body);
        setReconciliationData(sortedData);
      }
    } catch (error) {
      console.error("Reconciliation failed", error);
    }
  };

  const handleCancelReasonSave = () => {
    if (!cancelReason.trim()) {
      toaster("error", "Cancellation reason is required");
      return;
    }

    saveReconciliationData({
      row: cancelRow,
      receiptStatus: "CANCELLED",
      cancellationReason: cancelReason,
    });

    setShowCancelModal(false);
    setCancelRow(null);
    setCancelReason("");
  };

  const toInputDate = (dateStr) => {
    if (!dateStr) return "";

    // Already YYYY-MM-DD
    if (/^\d{4}-\d{2}-\d{2}/.test(dateStr)) {
      return dateStr.split("T")[0];
    }

    // DD-MM-YYYY HH:mm:ss
    const [datePart] = dateStr.split(" ");
    const [dd, mm, yyyy] = datePart.split("-");

    return yyyy ? `${yyyy}-${mm}-${dd}` : "";
  };

  const toApiDateFormat = (inputDate) => {
    if (!inputDate) return "";

    // inputDate = YYYY-MM-DD
    const [yyyy, mm, dd] = inputDate.split("-");

    return `${dd}-${mm}-${yyyy} 00:00:00`;
  };

  const isReconcileButtonDisabled = () => {
    if (!reconciliationData || reconciliationData.length === 0) return false;

    const todayDate = convertDateInFormat(new Date(), "DD-MM-YYYY");

    return reconciliationData.some((item) => {
      if (!item.reconciliationStatus) return false;

      const recordDate = item.receiptDateTime.split(" ")[0];

      return recordDate === todayDate;
    });
  };

  const branchCodes = [
    83,35,108,229,98,238,101,63,25,125,126,75,117,214,81,13,350,115,86,52,33,
    34,9,164,118,16,133,99,176,89,94,283,41,263,213,158,183,139,294,144,2,349,
    110,96,64,351,68,268,120,80,15,140,257,71,259,91,335,30,258,207,70,265,211,
    342,300,261,346,217,179,17,178,356,370,7,357,273,306,245,290,208,234,56,203,
    6,239,66,109,250,330,163,254,19,352,4,49,216,241,308,320,311,324,364,304,
    326,354,29,212,210,366,152,288,359,123,102,313,218,307,327,277,59,88,243,
    256,341,240,301,345,269,310,168,10,138,195,280,242,266,106,360,260,267,31,
    105,272,331,228,48,26,312,233,247,53,315,39,289,333,343,57,314,5,274,363,
    271,184,264,113,322,76,206,121,355,32,231,237,279,348,47,353,62,112,172,
    145,61,129,339,275,45,67,276,14,249,340,119,248,318,93,116,358,244,202,
    28,325,278,235,85,87,146,295,305
  ];

  const branchList = branchCodes.map(code => ({
    code: String(code),
    name: String(code)   // no branch name available
  }));


  return (
    <>
    {
      showReconcileMessage && (
                <div class="empty-state">
  <div class="empty-state__icon">🔍</div>
  <h2 class="empty-state__title">No reconciliation records found.</h2>
  <p class="empty-state__message">
     There are no transactions are available to reconcile at this time.
  </p>
</div>
      )
    }
      {reconciliationData && reconciliationData.length > 0 && (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <FilterComponent
            status={statusFilter}
            onStatusChange={setStatusFilter}
            proposalNumber={proposalNumberFilter}
            onProposalNumberChange={setProposalNumberFilter}
          />
        </div>
      )}
      {reconciliationData && reconciliationData.length > 0 && (
        <div className="reconciliation-table-wrapper">
          <DataTable
            cellHeaders={[
              "Proposal No",
              "Policy No",
              "Policy Owner Name",
              "Mcustomer Ack No",
              "Product Name",
              "Service Type",
              "Channel Name",
              "Sub Channel Name",
              "Region",
              "Branch Name",
              "Agent/SP Code",
              "Agent/SP Name",
              "Next Level Supervisor",
              "Proposal Submission Date",
              "Instrument Type",
              "Instrument Number",
              "Instrument Amount",
              "Instrument Ack Date",
              "BOPS User",
              "Instrument Current Status",
              "Remarks",
              "Instrument Transaction Date",
              "Receipt Date & Time",
              "Bank Name",
              "IFSC Code",
              "Policy Status",
              "Policy Status updated on",
              "Edit",
              "Receipt Status",
              "Reason",
            ]}
            keys={[
              "proposalNumber",
              "policyNumber",
              "policyOwnerName",
              "mcustomerAcknowledgementNo",
              "productName",
              "serviceType",
              "channelName",
              "subChannelName",
              "region",
              "branchName",
              "agentSPCode",
              "agentSPName",
              "nextLevelSupervisorName",
              "proposalSubmissionDate",
              "instrumentType",
              "instrumentNumber",
              "instrumentAmount",
              "instrumentAcknowledgementDate",
              "bopsUserAcknowledged",
              "instrumentCurrentStatus",
              "remarks",
              "instrumentTransactionDate",
              "receiptDateTime",
              "bankName",
              "ifscCode",
              "policyStatus",
              "policyStatusUpdatedOn",
              "edit",
              "receiptStatus",
              "cancellationReason",
            ]}
            data={prepareTableData(filteredData)}
            fileName="Reconciliation-Report"
            addSerialNo={true}
            showExcelDownload={false}
            PerPageApiData={false}
            paginationItems={filteredData}
            alwaysShown={false}
          />
        </div>
      )}

      {reconciliationData && reconciliationData.length > 0 && (
        <button
          className="searchbt reconcile-btn"
          onClick={handleReconcile}
          disabled={isReconcileButtonDisabled()}
        >
          Reconcile & Save
        </button>
      )}

      {showEditModal && (
        <MobilePopUp
          onClose={closeEditPopup}
          heading="Edit Reconciliation Details"
        >
          <div className="reconciliation-edit-form">
            {/* Row 1 */}
            <div className="form-halfs">
              <div className="input-fields-wrapper">
                <label>Instrument Type</label>
                <select
                  className="input-field"
                  value={selectedRow?.instrumentType || ""}
                  onChange={(e) =>
                    updateEditField("instrumentType", e.target.value)
                  }
                >
                  <option value="CHEQUE">Cheque</option>
                  <option value="DEMAND_DRAFT">Demand Draft</option>
                </select>
              </div>

              <div className="input-fields-wrapper">
                <label>Instrument Number</label>
                <input
                  type="text"
                  className="input-field"
                  value={selectedRow?.instrumentNumber || ""}
                  onChange={(e) =>
                    updateEditField("instrumentNumber", e.target.value)
                  }
                  placeholder="Enter"
                />
              </div>
            </div>

            {/* Row 2 */}
            <div className="form-halfs">
              <div className="input-fields-wrapper">
                <label>Instrument Amount</label>
                <input
                  type="number"
                  className="input-field"
                  value={selectedRow?.instrumentAmount || ""}
                  onChange={(e) =>
                    updateEditField("instrumentAmount", e.target.value)
                  }
                  placeholder="Enter"
                />
              </div>

              <div className="input-fields-wrapper">
                <label>Instrument Transaction Date</label>
                <input
                  type="date"
                  className="input-field"
                  value={
                    toInputDate(selectedRow?.instrumentTransactionDate) || ""
                  }
                  onChange={(e) =>
                    updateEditField(
                      "instrumentTransactionDate",
                      toApiDateFormat(e.target.value)
                    )
                  }
                />
              </div>
            </div>

            {/* Row 3 */}
            <div className="form-halfs">
              <div className="input-fields-wrapper">
                <label>IFSC Code</label>
                <input
                  type="text"
                  className="input-field"
                  value={selectedRow?.ifscCode || ""}
                  onChange={(e) => handleIfscChange(e.target.value)}
                  maxLength="11"
                  placeholder="Enter"
                />
              </div>

              <div className="input-fields-wrapper">
                <label>Bank Name</label>
                <input
                  type="text"
                  className="input-field"
                  value={selectedRow?.bankName || ""}
                  disabled
                  placeholder="Auto fetched"
                />
              </div>
            </div>

            {/* Row 4 */}
            <div className="form-halfs">
              <div className="input-fields-wrapper">
                <label>Reason</label>
                <input
                  type="text"
                  className="input-field"
                  value={selectedRow?.cancellationReason || ""}
                  onChange={(e) =>
                    updateEditField("cancellationReason", e.target.value)
                  }
                  placeholder="Enter"
                />
              </div>

              <div className="input-fields-wrapper">
                <label>Remarks</label>
                <input
                  type="text"
                  className="input-field"
                  value={selectedRow?.remarks || ""}
                  onChange={(e) => updateEditField("remarks", e.target.value)}
                  placeholder="Enter"
                />
              </div>
            </div>

            {/* Row 5 : Change Branch */}
            {window.envType === "DEV" && <div className="form-halfs change-branch-row">
              {/* LEFT SIDE - Confirmation */}
              <div className="input-fields-wrapper checkbox-wrapper">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={isBranchChangeConfirmed}
                    onChange={(e) =>
                      setIsBranchChangeConfirmed(e.target.checked)
                    }
                  />
                  <span>I confirm branch change for this proposal</span>
                </label>
              </div>

              {/* RIGHT SIDE - Dropdown */}
              <div className="input-fields-wrapper">
                <label>Change Branch</label>

                <Select
                  classNamePrefix="change-branch"
                  className="change-branch-select"
                  options={branchList}
                  isDisabled={!isBranchChangeConfirmed}
                  getOptionLabel={(option) => option.name} 
                  getOptionValue={(option) => option.code}
                  value={
                    selectedRow?.assignedBranchName
                      ? branchList.find(
                          (b) => b.code === selectedRow.assignedBranchName,
                        )
                      : null
                  }
                  onChange={(selected) => {
                    updateEditField("assignedBranchName", selected.code);
                  }}
                  isSearchable
                  filterOption={(option, inputValue) =>
                    // inputValue.length >= 3 &&
                    option.data.name
                      .toLowerCase()
                      .includes(inputValue.toLowerCase())
                  }
                />

                <span className="changeBranch-disclaimer">
                  *All the entries of this proposal will be moved to the new
                  branch
                </span>
              </div>
            </div>}

            {/* Save Button */}
            <button className="btn-pay" onClick={handleEditSave}>
              Save
            </button>
          </div>
        </MobilePopUp>
      )}

      {showCancelModal && (
        <MobilePopUp
          onClose={() => setShowCancelModal(false)}
          heading="Cancel Receipt"
          cssClass="cancel-reason-popup"
        >
          <div className="reconciliation-edit-form cancel-receipt-form">
            <div className="input-fields-wrapper">
              <label>Cancellation Reason</label>
              <input
                type="text"
                className="input-field"
                value={cancelReason}
                onChange={(e) => setCancelReason(e.target.value)}
                placeholder="Enter cancellation reason"
              />
            </div>

            <button className="btn-pay" onClick={handleCancelReasonSave}>
              Save
            </button>
          </div>
        </MobilePopUp>
      )}
    </>
  );
};

export default Reconciliation;
